import React, { useEffect, useState } from 'react'

import AvatarCarousel from './AvatarCarousel'

//查成交價
export const CheckCarItem: React.FC<any> = ({ kindsData }) => {
  return (
    <div id={'CheckCarItem'} className='mb-30'>
      <div className='flex justify-center items-center mb-10'>
        <p className="mr-8 text-18">提交後可查看成交價</p>
        <p className="text-24 text-[#FF0000] font-medium">{kindsData?.minimumPrice || "？萬"}</p>
      </div>
      {!!kindsData?.brandId &&
        <div className="flex justify-center items-center">
          <AvatarCarousel kindsData={kindsData} inquiryUsers={kindsData?.inquiryUsers} />
          <p className="text-16 text-[#666]">
            已有{kindsData?.inquiryCount}人獲得成交價
          </p>
        </div>
      }
    </div>
  )
}

//分期購車
export const InstallmentItem: React.FC<any> = ({ kindsData }) => {
  return (
    <div id="InstallmentItem" className="flex justify-center mb-30 w-300 mx-auto">
      <div
        className="bg-full bg-no-repeat bg-cover w-280 h-80 flex flex-col justify-center items-center"
      >
        <div className="w-full flex items-center flex-col">
          <p className="text-18 font-medium  text-black mb-10 ">
            頭款（元）
          </p>
          <p className="text-[#ff0000]  text-24 font-medium">
            {kindsData?.loan?.downPayment || "？？？？元"}
          </p>
        </div>
      </div>
      <div className="container bg-no-repeat bg-cover w-280 h-80 flex flex-col justify-center items-center">
        <p className="text-18 font-medium  text-black mb-10">
          月貸（元）
        </p>
        <p className="text-[#ff0000]  text-24 font-medium">
          {kindsData?.loan?.monthsPayment || "？？？？元"}
        </p>
      </div>
    </div>
  )
}

//查成交價
export const CurrentCarItem: React.FC<any> = ({ kindsData }) => {
  return (
    <div id="CurrentCarItem" className="mb-30 w-full text-center">
      <div className='text-18 text-black'>提交查詢請求，提供準確結果</div>
      <div className='text-16 text-[#999] mt-20'>現車變動較快，以業代溝通為準</div>
    </div>
  )
}

// 預約試駕
export const BookDriveItem: React.FC<any> = ({ kindsData }) => {
  return (
    <div id="BookDriveItem" className="mb-30 w-full text-center">
      <div className='text-18 text-black'>提交試駕請求，輕鬆開啟座駕探索</div>
    </div>
  )
}


//汽車保險
export const Insurance: React.FC<any> = ({ kindsData }) => {
  return (
    <div id="Insurance" className="flex justify-center mb-30 w-300 mx-auto">
      <div
        className="bg-full bg-no-repeat bg-cover w-280 h-80 flex flex-col justify-center items-center"
      >
        <div className="w-full flex items-center flex-col">
          <p className="text-18 font-medium  text-black mb-10 ">
            必要花費（元）
          </p>
          <p className="text-[#ff0000]  text-24 font-medium">
            {kindsData?.expenses || "?"}
          </p>
        </div>
      </div>
      <div className="container bg-no-repeat bg-cover w-280 h-80 flex flex-col justify-center items-center">
        <p className="text-18 font-medium  text-black mb-10">
          保險（元）
        </p>
        <p className="text-[#ff0000]  text-24 font-medium">
          {kindsData?.insurance || "?"}
        </p>
      </div>
    </div>
  )
}